import { useSearchParams } from 'react-router'

import { useFlag } from '~/hooks/useFlag'
import { trackUserEvent } from '~/utils/analytics'

import { useUnreadInboxEntriesQuery } from './useInbox'

export const INBOX_OPEN_STATE_SEARCH_PARAM = 'inboxOpen'

export const useInboxDrawer = () => {
    const isInboxEnabled = useFlag('inbox')
    const [searchParams, setSearchParams] = useSearchParams()
    const isDrawerOpen = isInboxEnabled && searchParams.get(INBOX_OPEN_STATE_SEARCH_PARAM) === 'true'
    const { data: unreadCount } = useUnreadInboxEntriesQuery()

    const openDrawer = () => {
        setSearchParams(prev => {
            prev.set(INBOX_OPEN_STATE_SEARCH_PARAM, 'true')
            return prev
        })
        trackUserEvent('INBOX_OPENED', {
            unreadCount,
        })
    }

    const closeDrawer = () => {
        setSearchParams(prev => {
            prev.delete(INBOX_OPEN_STATE_SEARCH_PARAM)
            return prev
        })
    }

    const toggleDrawer = () => {
        setSearchParams(prev => {
            if (prev.get(INBOX_OPEN_STATE_SEARCH_PARAM) === 'true') {
                prev.delete(INBOX_OPEN_STATE_SEARCH_PARAM)
            } else {
                prev.set(INBOX_OPEN_STATE_SEARCH_PARAM, 'true')
                trackUserEvent('INBOX_OPENED', {
                    unreadCount,
                })
            }
            return prev
        })
    }

    return { isDrawerOpen, openDrawer, closeDrawer, toggleDrawer }
}
